import React from "react";
import { Link } from "react-router-dom";

export const PatientCell = ({ patient }) => {
    return patient ?
        <Link
            to = { `/patients/${ patient.id }/profil` }
            style = {{ whiteSpace: 'unset' }}
            className = "table__color__links"
        >
            <span> { patient.last_name } </span>
            <br />
            <span> { patient.first_name } </span>
        </Link>
        :
        <span> Non définie </span>;
}


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/AppointmentsTable/Cell/PatientCell.js